function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { AVAILABLE_COUNTRIES_LIST, COUNTRIES_LIST_ALL, getCountryUnavailableForShipmentValidationMessage } from '../constants/countries.constants';
import { CANADA_STATES_LIST, COUNTRIES_WITH_STATES, COUNTRY_CODES, USA_STATES_LIST } from '../constants/shipping.constants';
export let CountriesStatesSelect = /*#__PURE__*/function (CountriesStatesSelect) {
  CountriesStatesSelect["US"] = "US";
  CountriesStatesSelect["CA"] = "CA";
  return CountriesStatesSelect;
}({});
export function getStates(country) {
  switch (country) {
    case CountriesStatesSelect.CA:
      {
        return CANADA_STATES_LIST;
      }
    default:
      return USA_STATES_LIST;
  }
}
export function getDefaultValue(country) {
  if (!country) {
    return '';
  }
  switch (country) {
    case CountriesStatesSelect.CA:
      {
        return CANADA_STATES_LIST[0].code;
      }
    case CountriesStatesSelect.US:
      {
        return USA_STATES_LIST[0].code;
      }
    default:
      return '';
  }
}
export const getStateByStateCode = (stateCode, country = COUNTRY_CODES.US, returnNull = false) => {
  const state = getStates(country).find(st => st.code === stateCode);
  if (returnNull && !state) {
    return null;
  }
  if (!state) {
    return {
      name: stateCode
    };
  }
  return state;
};
export const checkToAddress = order => {
  const {
    address,
    zip,
    country,
    city,
    fnameShipping,
    lnameShipping
  } = order;
  return !!address && !!zip && !!country && !!city && !!fnameShipping && !!lnameShipping;
};
function sortCountries(country1, country2) {
  if (country1.code === COUNTRY_CODES.US) {
    return -1;
  }
  if (country2.code === COUNTRY_CODES.US) {
    return 1;
  }
  return country1.label.localeCompare(country2.label);
}
export const COUNTRIES = AVAILABLE_COUNTRIES_LIST.map(country => ({
  code: country.cca2,
  label: country.common
})).sort(sortCountries);
const COUNTRIES_BY_CODE = COUNTRIES.reduce((acc, item) => _objectSpread({}, acc, {
  [item.code]: item.label
}), {});
export const getCountryByCode = code => {
  const countryCode = code.toUpperCase();
  return COUNTRIES_BY_CODE[countryCode];
};
export function checkIsCountryWithStates(country) {
  return COUNTRIES_WITH_STATES.includes(country);
}
export const validateCountryForShipment = countryCca2Code => {
  const countryFullData = COUNTRIES_LIST_ALL.find(({
    cca2
  }) => cca2 === countryCca2Code);
  if (!countryFullData) {
    return getCountryUnavailableForShipmentValidationMessage();
  }
  return countryFullData.isShipmentUnavailable ? getCountryUnavailableForShipmentValidationMessage(countryFullData.common) : null;
};